"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_transformer_1 = require("class-transformer");
const Resource_1 = __importDefault(require("../Resource"));
const ERegimeFiscal_1 = require("../../enums/CorporationSheet/ERegimeFiscal");
const ClientSheetLightResponseResource_1 = __importDefault(require("../ClientSheet/ClientSheetLightResponseResource"));
const class_validator_1 = require("class-validator");
class CorporationSheetLightResponseResource extends Resource_1.default {
    constructor() {
        super(...arguments);
        this.createdAt = null;
        this.updatedAt = null;
        this.representantLegal = null;
    }
}
exports.default = CorporationSheetLightResponseResource;
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], CorporationSheetLightResponseResource.prototype, "id", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], CorporationSheetLightResponseResource.prototype, "raisonSociale", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], CorporationSheetLightResponseResource.prototype, "regimeFiscal", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], CorporationSheetLightResponseResource.prototype, "assujettiIFI", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Object)
], CorporationSheetLightResponseResource.prototype, "createdAt", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Object)
], CorporationSheetLightResponseResource.prototype, "updatedAt", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => ClientSheetLightResponseResource_1.default),
    __metadata("design:type", Array)
], CorporationSheetLightResponseResource.prototype, "beneficiaries", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => ClientSheetLightResponseResource_1.default),
    __metadata("design:type", Object)
], CorporationSheetLightResponseResource.prototype, "representantLegal", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], CorporationSheetLightResponseResource.prototype, "corporationId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], CorporationSheetLightResponseResource.prototype, "creatorId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], CorporationSheetLightResponseResource.prototype, "isComplete", void 0);
